// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"705b1c31","404":"522c0981","463":"cae05cc8","598":"4975352b","744":"20dac183","787":"1c7a3ac1"}[chunkId] + ".chunk.js";
};